import React from 'react'

import ExportResultDialog from './export-result-dialog'
import ExportStatusDialog from './export-status-dialog'

const ExportItemsRoot = () => {
  return (
    <>
      <ExportResultDialog />
      <ExportStatusDialog />
    </>
  )
}

export default ExportItemsRoot
